import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { BrandFilterContainerComponent } from './brand-filter-container.component';
import { BrandGeographyDialogModule } from './brand-geography-dialog/brand-geography-dialog.module';
import { BrandGroupDialogModule } from './brand-group-dialog/brand-group-dialog.module';
import { BrandLocationDialogModule } from './brand-location-dialog/brand-location-dialog.module';
import { BrandSourceDialogModule } from './brand-source-dialog/brand-source-dialog.module';
import { BrandTaxonomyDialogModule } from './brand-taxonomy-dialog/brand-taxonomy-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    BrandSourceDialogModule,
    BrandTaxonomyDialogModule,
    BrandLocationDialogModule,
    BrandGroupDialogModule,
    BrandGeographyDialogModule,
    MatBadgeModule,
  ],
  exports: [BrandFilterContainerComponent],
  declarations: [BrandFilterContainerComponent],
})
export class BrandFilterContainerModule {}
